import React from "react";
import { useTranslation } from "react-i18next";
import getSymbolFromCurrency from 'currency-symbol-map';
import ButtonComponent from "./ButtonComponent";
import { getLockerSizeLabel, getPathForNextPage, getUnitLabelParams, isPodBankType } from "../lib/Utils";
import { INVOICE, USER_ACCOUNT } from "../assets/constants/PageList";
import { BUY } from "../assets/constants/Constants";
import { useHistory } from 'react-router-dom';
import { getSecureItemFromSpecificStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE, LS_LOCKER_BANK_INFO } from "../assets/constants/BrowserStorageKeys";

export default function UserLockersHistoryComponent({ locker }) {
  const { t } = useTranslation();
  const history = useHistory();
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const unitLabelParams = getUnitLabelParams(locker?.BankType ?? lockerBankInfo?.LockerBankType, t);
  const isPodLocker = isPodBankType(locker?.BankType ?? lockerBankInfo?.LockerBankType);

  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "", time: "" };

    const date = new Date(dateString);
    if (isNaN(date)) return { date: "", time: "" };

    const datePart = date.toLocaleDateString('en-GB');
    const timePart = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return {
      date: datePart,
      time: timePart,
    };
  };

    const formatTimeToAmPm = (timeValue) => {
    if (!timeValue || typeof timeValue !== "string") return timeValue;

    const normalizedTime = timeValue.trim().toUpperCase();
    if (normalizedTime.includes("AM") || normalizedTime.includes("PM")) {
      return normalizedTime;
    }

    const [hoursString, minutesString = "00"] = normalizedTime.split(":");
    const hours = Number(hoursString);
    const minutes = Number(minutesString);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return timeValue;
    }

    const suffix = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = String(minutes).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes} ${suffix}`;
  };

  const checkIn = formatDateTime(locker?.reserve_start);
  const checkOut = formatDateTime(locker?.reserve_end);
  const isBuyProduct = locker?.product_type === BUY;
   const downloadInvoice = () => {
          history.push({
              pathname: getPathForNextPage(USER_ACCOUNT, INVOICE),
              state: { lockerItem : locker },
          });
      };


  return (
    <div className="locker-card">
      <div className="top">
        <div className="title">{locker?.locker_bank_name}</div>
        <div className="status">{locker?.status}</div>
      </div>
      <div className="sub-text">
        {isBuyProduct && locker?.product_name && (
          <div className="product-name">{locker.product_name}</div>
        )}
        {t("locker_size_locker_text", { size: getLockerSizeLabel(locker?.door_size, t), ...unitLabelParams })}
        {!isPodLocker && (
          <span> {t("door_number_label", { doorNumber: locker?.door_number })}</span>
        )}
      </div>
      {isBuyProduct ? (
        <div className="transaction-details">
          <div className="detail-row">
            <span className="label">{t("purchased_label")}</span>
            <span className="value">{checkIn.date} {formatTimeToAmPm(checkIn.time)}</span>
          </div>
        </div>
      ) : (
        <div className="date-section">
          <div className="date-box">
            <span className="label">{t("check_in_label")}</span>
            <span className="value">{checkIn.date}</span>
            <span className="value">{formatTimeToAmPm(checkIn.time)}</span>
          </div>

          <div className="date-box">
            <span className="label">{t("check_out_label")}</span>
            <span className="value">{checkOut.date}</span>
            <span className="value">{formatTimeToAmPm(checkOut.time)}</span>
          </div>
        </div>
      )}
      {!isPodLocker && (
        <>
          <div className="total">
            {t(isBuyProduct ? "amountPaidText" : "total_label")}: {getSymbolFromCurrency(locker?.currency)} {locker?.amount}
          </div>
          <hr />
          <ButtonComponent title={t("invoice_Details")} handleClick={() => downloadInvoice()} />
        </>
      )}
    </div>
  );
}
